// ============= Imports =============
import React from 'react';
import { Grid, Row } from './styles';

// ============= Component =============
export const CompactVisualPromptSkeleton: React.FC = () => (
  <Grid>
    {Array.from({ length: 6 }).map((_, i) => (
      <Row key={i} />
    ))}
  </Grid>
);
